import type { TranslationMessages } from '../../types';

export const shift_planning: TranslationMessages = {
  loading: 'Loading shift planning...',
  create_success: 'Shift created successfully!',
  create_error: 'Failed to create shift',
  update_success: 'Shift updated successfully!',
  update_error: 'Failed to update shift',
  delete_success: 'Shift deleted successfully!',
  delete_error: 'Failed to delete shift',
  scheduled_shifts_title: 'Scheduled Shifts',
  scheduled_shifts_description: 'Manage and monitor all staff shifts',
  table_staff: 'Staff Member',
  table_datetime: 'Date & Time',
  table_position: 'Position',
  table_location: 'Location',
  table_status: 'Status',
  table_actions: 'Actions',
  create_title: 'Create New Shift',
  create_description: 'Schedule a new shift for a staff member',
  edit_title: 'Edit Shift',
  edit_description: 'Update shift details',
  staff_label: 'Staff Member *',
  staff_placeholder: 'Select staff member',
  date_label: 'Date *',
  start_time_label: 'Start Time *',
  end_time_label: 'End Time *',
  position_label: 'Position (Optional)',
  position_placeholder: 'Select position',
  location_label: 'Location (Optional)',
  location_placeholder: 'Enter location',
  notes_label: 'Notes',
  notes_placeholder: 'Additional notes for this shift...',
  recurring_label: 'Make this a recurring shift',
  recurring_pattern_label: 'Recurring Pattern',
  recurring_pattern_placeholder: 'Select pattern',
  recurring_weekly: 'Weekly',
  recurring_biweekly: 'Bi-weekly',
  recurring_monthly: 'Monthly',
  create_button: 'Create Shift',
  update_button: 'Update Shift',
  delete_button: 'Delete',
  delete_confirm: 'Are you sure you want to delete this shift?',
};
